module.exports = __webpack_public_path__ + "img/circle-check.935d56bf.png";